import { Heading, Icon, IconButton, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Pressable } from 'react-native';

export interface HeaderProps {
  headerTitle: string;
  handleGoBack: () => void;
}

export const Header = ({ headerTitle, handleGoBack }: HeaderProps) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  if (isMobile) {
    return (
      <VStack pt={Spacing['inset.md']} px={Spacing['inline.xxxs']} space={Spacing['inset.nano']}>
        <HStack alignItems="center" justifyContent="space-between">
          <HStack alignItems="center" space={Spacing['inline.xxs']}>
            <Pressable onPress={handleGoBack}>
              <Icon name="ArrowLeft" color={Color['brand.primary.principal']} size="xxs" />
            </Pressable>
            <Text
              testId="qa"
              variant="semibold"
              lineHeight="distant"
              fontSize={Typography['fontsize.lg']}>
              {headerTitle}
            </Text>
          </HStack>
        </HStack>
      </VStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" py={Spacing['inset.md']}>
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={handleGoBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Heading testId="qa" size="h2">
          Detalhes de {headerTitle}
        </Heading>
      </HStack>
    </HStack>
  );
};
